import { Loader2 } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/Button.jsx";
import { Card, CardContent } from "../../components/ui/Card.jsx";
import { Input } from "../../components/ui/Input.jsx";
import { Label } from "../../components/ui/Label.jsx";
import { useToast } from "../../hooks/useToast.js";
import { login, setSuperAdminToken, getSuperAdminToken } from "../../services/authService.js";

export default function SuperAdminLogin() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) return;

    setLoading(true);
    try {
      const res = await login({ email, password });
      if (res.success && res.token) {
        // Decode token to check role
        const payload = JSON.parse(atob(res.token.split(".")[1]));
        if (payload.user_role !== "super_admin") {
          toast({
            variant: "destructive",
            title: "Access Denied",
            description: "This login is for super admins only.",
          });
          return;
        }
        setSuperAdminToken(res.token);
        navigate("/super-admin/dashboard");
      } else {
        toast({
          variant: "destructive",
          title: "Login Failed",
          description: res?.error || "Invalid credentials",
        });
      }
    } catch (err) {
      toast({
        variant: "destructive",
        title: "Error",
        description: err.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-sm border-gray-200">
        <CardContent className="p-6 space-y-5">
          <div className="text-center">
            <h1 className="text-xl font-bold text-gray-900">LeadCRM</h1>
            <p className="text-xs text-gray-400 mt-1">Super Admin Portal</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-3">
            <div>
              <Label>Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@leadcrm.com"
                className="h-9 text-sm"
                required
              />
            </div>
            <div>
              <Label>Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="h-9 text-sm"
                required
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full h-9 text-sm bg-gradient-to-r from-[#00a8b4fa] to-[#00c8d391] text-white"
            >
              {loading ? <Loader2 size={16} className="animate-spin" /> : "Login"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
